import React, {useState} from "react";
import DeviceSettingsModal from "./DeviceSettingsModal";
import Settings from "../../../assets/img/movement/settings.svg";
import ExpandVideo from "../../../assets/img/movement/ExpandVideo.svg";
import AudioMute from "../../../assets/img/movement/AudioMute.svg";
import VideoUnmute from "../../../assets/img/movement/VideoUnmute.svg";
import GLOBAL from "../../../global";
import './VideoToolbar.scss';

const FACING_MODE_USER = "user";
const FACING_MODE_ENVIRONMENT = "environment";

const VideoToolbar = ({
    isFullScreenVideo,
    onClickFullScreen,
    updateWebCamConstraints,
    onClickSwitchCamera,
    webcamConstraints,
    isCorrectOrientation = true,
    selectedExercise
}) => {

    const [facingMode, setFacingMode] = useState(FACING_MODE_USER);
    const [deviceSettingsModal, setDeviceSettingsModal] = useState(false);

    const onClickFullScreenVideo = (e) => {
        e.preventDefault();

        // Check if this is a common movement with orientation requirement
        const exerciseCodeName = selectedExercise?.ExerciseCodeName;
        const faceOrientation = selectedExercise?.FaceOrientation;

        const isCommonMovementWithOrientation =
            exerciseCodeName !== 'calibration' &&
            exerciseCodeName !== 'postureAnalysis' &&
            faceOrientation;

        // Only allow fullscreen click if orientation is correct (or if exercise doesn't require orientation)
        if (isCommonMovementWithOrientation && !isCorrectOrientation) {
            console.log('orientation not correct - preventing fullscreen click');
            return;
        }

        onClickFullScreen();
    }

    const onClickInputDeviceSettingsModal = (e) => {
        e.preventDefault();
        setDeviceSettingsModal(!deviceSettingsModal);
    };
    const onClickSwitchCameraFacing = (e) => {
        e.preventDefault();
        onClickSwitchCamera();
    };

    return (
        <>
            <div className="video-toolbar__box">
                <div className="video-toolbar__button--padding-bottom video-toolbar__button--expand">
                    <div className="video-toolbar__button">
                        <a rel="noopener noreferrer" href={"!#"}
                        onClick={(e)=>onClickFullScreenVideo(e)}
                        id="expand">
                            {isFullScreenVideo && (
                                <img src={ExpandVideo} alt="ExpandVideo"/>
                            )}
                            {!isFullScreenVideo && (
                                <img src={ExpandVideo} alt="ExpandVideo"/>
                            )}
                        </a>
                    </div>
                </div>
                {GLOBAL.DEVICE_WIDTH >= 1000 && (
                    <div className="video-toolbar__button">
                        <a rel="noopener noreferrer" href={"!#"}
                            className="toolbar-item"
                            onClick={onClickInputDeviceSettingsModal}
                            id="camera-settings">
                                <img src={Settings} alt="settings"/>
                        </a>
                    </div>
                 ) //: 
                //     <div className="video-toolbar__button">
                //         <button rel="noopener noreferrer" href={"!#"}
                //             className="toolbar-item"
                //             onClick={onClickSwitchCameraFacing}
                //             id="camera-settings">
                //                 <i class="fa-solid fa-camera-rotate"></i>
                //         </button>
                //     </div>
                }
            </div>
            {!isFullScreenVideo && (
                <DeviceSettingsModal
                    openModal={deviceSettingsModal}
                    toggleModal={onClickInputDeviceSettingsModal}
                    onSelectChangeDevice={updateWebCamConstraints}
                    webcamConstraints={webcamConstraints}
                />
            )}
        </>
    );

}

export default VideoToolbar;